/**
* @Author: zachalam
* @Date:   2017-02-06T13:55:21-08:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-02-06T13:55:22-08:00
*/

import _ from 'lodash';

let initialState = {
  data: null,
  likes: null,
  tags: null
};

const trip = (state = initialState, action) => {
  switch(action.type) {
    case 'STORE_TRIPLIKES':
      var oldState = _.map(state.likes,(v)=>{return v; });
      let newState = {
        ...state,
        likes: oldState.concat(action.payload)
      };
      return newState;
    case 'CLEAR_TRIPLIKES':
      return {
        likes: null
      }
    case 'STORE_TRIP':
      return {
        ...state,
        data: {...action.payload}
      }
    case 'FAVORITE_TRIP_LIKED_USER':
      // favorite a user who liked one of your trips.
      let favKey = action.payload;
      var newLikes = _.map(state.likes,(v)=>{return v; });
      // swap status
      let favStatus = newLikes[action.payload].other_account.data.is_favorite;
      if(favStatus == null) newLikes[action.payload].other_account.data.is_favorite = true;
      else newLikes[action.payload].other_account.data.is_favorite = null;

      return {
        ...state,
        likes: newLikes
      }

     case 'STORE_TAG_LIST':
      return {
        ...state,
        tags: action.payload
      }
      
      case 'JOIN_TRIP_STORE':
        let newTrip = Object.assign({}, state.data, state.data.is_liked=true)
        
        return {
          ...state,
          data: {...newTrip}
        }
    default:
      return state;
  }
}



export default trip;



// WEBPACK FOOTER //
// ./src/reducers/trip.js